<template>
  <div id="app" >
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style>
@font-size-base: 75;

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #F0F2F5;
  

}
body{
  background-color: #F0F2F5;
  /* height: 812px; */
}

@font-face{
    font-family: 'rui';                           /* 自定义字体名字*/
    src : url('https://www.urbanservices.cn/font.ttf');       /*告诉浏览器在哪可以找到这个字体*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue